export function getSchedulingAssistantViewStateId(formId: string): string {
    // Scheduling assistant requires a unique viewStateId for each instance
    // Reusing the formId as that is already unique for each compose form, or reverting to
    // a default if that is null
    return formId ?? 'ComposeSchedulingAssistantId';
}
